import { GET_ALLCLIENT, GET_ALLCLIENT_SUCCESS, GET_ALLCLIENT_ERROR,GETSOCIALDP,GETSOCIALDP_SUCCESS,GETSOCIALDP_ERROR } from "../actions";

const initialState = {
    getAllClientLoading:false,
    getAllClientDetails:[],
    getAllClientError:"",
    getSocialDpLoading:false,
    getSocialDp:[],
    getSocialDpError:""
}

const scheduleReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_ALLCLIENT:
         return {
           ...state,
           getAllClientLoading: true,
         };
        case GET_ALLCLIENT_SUCCESS:
            return {
                ...state,
                getAllClientLoading: false,
                getAllClientDetails: action.payload,
            };
            case GET_ALLCLIENT_ERROR:
                return {
                    ...state,
                    getAllClientLoading:false,
                    getAllClientError:action.payload
                };
                case GETSOCIALDP:
         return {
           ...state,
           getSocialDpLoading: true,
         };
         case GETSOCIALDP_SUCCESS:
         return {
           ...state,
           getSocialDpLoading: false,
           getSocialDp:action.payload,
         };
         case GETSOCIALDP_ERROR:
            return {
              ...state,
              getSocialDpLoading: false,
              getSocialDpError:action.payload,
            };
                default:
                    return state;
    }
}

export default scheduleReducer